<crud-list class="height100p" [data]="table" [detailUrl]="definition.getAdminEditUrl()" [restUrl]="definition.apiEndpoint" [allowCreate]="definition.canInsert" [allowDelete]="definition.canDelete" (onDelete)="initData()">
</crud-list>
